
<template>
  <el-card shadow="never" class="box-card">
  <div slot="header" class="clearfix">
    <span>{{name}}</span>
  </div>
    <div class="text item">
      <el-row>
        <el-col :span="2" class="textMarginTop">
          URI:
        </el-col>
        <el-col :span="22">
          <el-input
              type="textarea"
              placeholder="Please input URI"
              v-model="uris"
              clearable>
          </el-input>  
        </el-col>
      </el-row>
      <el-row>
        <div class="tip">
            Just enter an URI, it's quite simple.
        </div>
      </el-row>
      <el-row>
        <el-col :span="3" class="textMarginTop">
          Referer:
        </el-col>
        <el-col :span="21">
          <el-input
              type="textarea"
              placeholder="Please input referer value"
              v-model="refs"
              clearable>
          </el-input>  
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="3" class="paramNameCol">
              Mode
          </el-col>
          <el-col :span="21">
              <el-select v-model="model.params.mode" placeholder="Select mode">
                  <el-option
                  v-for="item in modes"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
              </el-select>
          </el-col>
      </el-row>
      <el-row>
        <div class="tip">
            It substitutes an original 'referer' header value to a desired value
        </div>
      </el-row>
    </div>
   
</el-card>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
//import {prepareParam} from '../../../mixins/prepareParam'
export default {
    name: 'Open',
    props: {
        model: {
            type: Object,
            default: () => {}
        },
    },
    //mixins: [prepareParam],
    data () {
        return {
            refs: this.prepareParam(this, 'referer'),//called from mixin prepareParam
            name: 'Open',
            desc: 'Opens a desired page.',
            input: '',   
            uris: this.prepareParam(this, 'uri'),
            modes: ['random', 'by_index'],
        }
    },
    computed: {
        ...mapState('bot', {
        bot: 'bot',
        project: 'project',
        error: 'error',
        loading: 'loading',
        }),
    },
    watch: {
        uris(newValue, oldValue) {
            this.model.params.uri = newValue.replace(/\r\n/g,"\n").split("\n");
        },
        refs(newValue, oldValue) {
            this.model.params.referer = newValue.replace(/\r\n/g,"\n").split("\n");
        },
    },
}
</script>

<style lang="scss" scoped>
  #emptyImageWrapper{
    text-align: center;
    margin-top:30px;
    color:#aaa;
  }
  #nothingImage{
    margin: 0 auto;
    max-width: 50px
  }
  .emptyText{
    margin-top:20px;
  }
  .textMarginTop{
    margin-top:10px;
  }


</style>
